import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e5d9d95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row items-start justify-start q-ml-md" }
const _hoisted_2 = { class: "col-xs-10 col-md-4 column justify-start q-ma-md" }
const _hoisted_3 = { class: "text-h6" }
const _hoisted_4 = { class: "text-subtitle1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_card, {
        class: "my-card bg-grey-2",
        flat: "",
        bordered: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('serverinfo.title')), 1)
            ]),
            _: 1
          }),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('serverinfo.loading')), 1)
                ]),
                _: 1
              }))
            : (_ctx.error)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 1,
                  class: "text-negative"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('serverinfo.error')), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, "IP: " + _toDisplayString(_ctx.info.ipaddress), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, "TCP: " + _toDisplayString(_ctx.info.tcpport), 1),
                      _createElementVNode("div", null, "HTTP: " + _toDisplayString(_ctx.info.httpport), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, "MQTT: " + _toDisplayString(_ctx.info.mqttport), 1),
                      _createElementVNode("div", null, "MQTT SSL: " + _toDisplayString(_ctx.info.mqttsslport), 1),
                      _createElementVNode("div", null, "MQTT Web: " + _toDisplayString(_ctx.info.mqttwebport), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, "Arduino: " + _toDisplayString(_ctx.info.arduinoport), 1)
                    ]),
                    _: 1
                  })
                ], 64))
        ]),
        _: 1
      })
    ])
  ]))
}